import React, { useState } from 'react';
import {
  Badge, Tooltip,
} from 'reactstrap';

import PropTypes from 'prop-types';

const TooltipItem = ({
  id,
  value,
  label,
  color,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <h4>
      <Badge id={`Tooltip-${id}`} color={color}>
        {value}
      </Badge>
      {
        label ? (
          <Tooltip
            placement="top"
            isOpen={tooltipOpen}
            target={`Tooltip-${id}`}
            toggle={toggle}
          >
            {label}
          </Tooltip>
        ) : null
      }
    </h4>
  );
};

TooltipItem.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.string,
};


TooltipItem.defaultProps = {
  color: 'warning',
};


export default TooltipItem;
